<template>
  <div class="message-info">
    <div class="message-title">
      <div class="title-default">平台公告</div>
      <div class="message-list">
        <div class="null" v-show="noticeData.totalCount == 0">
          <img src="../../assets/img/pic_none.png" alt />
          <div>没有搜索到相关数据…</div>
        </div>
        <div
          class="message-item"
          v-for="(item, index) in noticeData.pageList"
          :key="index"
          @click="openDetail(item)"
        >
          <div class="message-item-title">
            <!-- <div class="hongdian"></div> -->
            {{ item.title }}
            <span>{{ item.createTime }}</span>
          </div>
          <div class="message-item-content">
            <img
              v-if="item.img != null && item.img != ''"
              :src="item.img"
              alt
            />
            <div class="notice-text">
              <div class="message-item-text">
                {{ getSimpleText(item.content) }}
                <!-- <div v-html="item.content"></div> -->
              </div>
              <div class="view-details">
                查看详情
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#iconbiaodan_rili_right" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        v-show="noticeData.totalCount > 12"
        class="fenye commodity-fenye"
        background
        layout="prev, pager, next"
        :total="noticeData.totalCount"
        :page-size="12"
        @current-change="pageSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      noticeData: {
        pageList: []
      }
    };
  },
  mounted() {
    var _this = this;
    if (Cookies.get("token") != undefined) {
      this.getNotice();
    }
  },

  methods: {
    pageSize(val) {
      this.page = val;
      this.getNotice();
    },
    //html剔除富文本标签，留下纯文本
    getSimpleText(html) {
      return html.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "");
    },
    // 获取平台公告列表
    getNotice() {
      var _this = this;
      this.$fetch(
        `/common/api/article?pageIndex=${this.page}&pageSize=12&typeCode=notice`
      ).then(res => {
        if (res.code == 0) {
          _this.noticeData = res.data;
        } else {
          this.$message(res.message);
        }
      });
    },
    openDetail(item) {
      this.$router.push({ name: "noticeDetail", params: item });
    }
  }
};
</script>
<style lang="scss">
.null {
  padding: 30px 261px;
  background: #fff;
  text-align: center;
  img {
    width: 375px;
    height: 94px;
  }
  div {
    color: #b4b7bc;
    font-size: 14px;
    margin-top: 8px;
    text-align: center;
  }
}
</style>
<style lang="scss" scoped>
.message-info {
  .title-default {
    border-bottom: 1px solid #e8eef5;
    background: #ffffff;
  }
  .message-tab {
    background: #ffffff;
    padding: 0px 20px;
    font-size: 14px;
    color: #2f3133;
    display: flex;
    // align-items: center;
    justify-content: space-between;
  }
  .message-tabs {
    display: flex;
    padding: 14px 0px;
  }
  .tabs {
    margin-right: 36px;
    cursor: pointer;
  }
  .total {
    color: #5e6066;
    font-size: 12px;
    padding: 17px 0;
    cursor: pointer;
  }
  .total:hover {
    color: #2f3133;
  }
  .selected {
    color: #3455d3;
    font-weight: bold;
    border-bottom: 1px solid #3455d3;
    padding-bottom: 3px;
  }
  .message-list {
    .message-item {
      margin-top: 10px;
      .message-item-title {
        position: relative;
        height: 44px;
        background: #f9fafa;
        color: #2f3133;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #dfe4eb;
        padding: 0 20px;
        span {
          color: #909399;
          font-size: 12px;
        }
        .hongdian {
          position: absolute;
          width: 5px;
          height: 5px;
          background: #f75658;
          border-radius: 50%;
          top: 10px;
          left: 10px;
        }
      }
      .message-item-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        background: #ffffff;
        padding: 20px 20px 20px 20px;
        color: #909399;
        font-size: 12px;
        cursor: pointer;
        .view-details {
          cursor: pointer;
        }
        img {
          width: 160px;
          height: 90px;
          margin-bottom: 10px;
        }
        .notice-text {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
        }
      }
      .message-item-content:hover {
        background: #f9fafa;
      }
      .message-item-text {
        color: #5e6066;
        width: 739px;
        height: 40px;
        overflow: hidden;
        text-overflow: clip;
        line-height: 20px;
        &/deep/img {
          display: none;
        }
      }
    }
  }
}
</style>
